<template>
  <div class="flex items-center gap-6">
    <button @click="selectGrape(slug)"
      class="panel px-4 py-2 text-left hover:border-wine/60 transition-colors"
      :class="depth === 0 ? 'border-wine/60' : ''">
      <p class="font-display" :class="depth === 0 ? 'text-lg' : 'text-sm'">
        {{ grape?.name || slug }}
      </p>
      <p v-if="grape && !grape.ancestor_only" class="text-[0.65rem] text-ink-faint">
        {{ grape.origin_region || grape.origin_country }}
      </p>
      <p v-else class="text-[0.65rem] text-gold-bright/70 italic">ancestral variety</p>
    </button>

    <div v-if="parents.length && depth < 5" class="relative flex flex-col gap-3 pl-6 border-l border-line">
      <PedigreeNode v-for="p in parents" :key="p" :slug="p" :depth="depth + 1" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { bySlug, selectGrape } from "../store"

const props = defineProps({ slug: String, depth: Number })
const grape = computed(() => bySlug.value.get(props.slug))
const parents = computed(() =>
  grape.value ? [grape.value.parent1_slug, grape.value.parent2_slug].filter(Boolean) : []
)
</script>
